import * as types from './types';
import createReducer from '../reducers';

const initialState = {
  token: null,
  loading: false,
  error: null,
};
const success = (state, { payload }) => ({
  ...state,
  token: payload,
  loading: false,
});

const request = (state, { payload }) => ({
  ...state,
  loading: payload
});

const error = (state, { payload }) => ({
  ...state,
  error: payload.userMessage,
  loading: false,
});

export default createReducer(initialState, {
  [types.REQUEST]: request,
  [types.SUCCESS]: success,
  [types.ERROR]: error,
});


// WEBPACK FOOTER //
// ./src/store/auth/reducer.js